module.exports = __webpack_public_path__ + "img/goods_bg.ca53fc1d.png";